import React, { Component } from 'react';
import {BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip} from 'recharts';

class CustomTooltip extends Component{
  
    render() {
      const { active, payload } = this.props;
      if (active && payload) {
        var p = payload[0].payload;
        return (
          <div className="custom-tooltip">
            <p className="custom-label" style={{color:'#000000'}}>{`${p.name}`}</p>
            <p className="custom-label" style={{color:'#585274'}}>{`Transactions : ${p.Txs}`}</p>
            <p className="custom-label" style={{color:'#278dc1'}}>{`Operations : ${p.Ops}`}</p>
          </div>
        );
      }
  
      return null;
    }
}

class LedgersChart extends Component {

    constructor(props){
        super(props);
        this.elem = null;
        this.state = {
            width: 1,
            height: 1
        }
    }

    updateDimensions(){
        if(this.elem != null){
            this.setState({
                width : this.elem.getBoundingClientRect().width,
                height : this.elem.getBoundingClientRect().height
            });
        }
    }

    componentDidMount(){
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions.bind(this));
    }

    componentWillUnmount(){
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    render(){
    
        return (
            <div style={{width:'100%', height: '228px', overflow:'hidden'}} ref={(elem)=>{this.elem = elem}}>
                <BarChart width={this.state.width} height={this.state.height} data={this.props.data}
                    margin={{top: 20, right: 30, left: 20, bottom: 5}} isAnimationActive={false}>
                    <XAxis 
                        isAnimationActive={false}
                        dataKey="name" 
                        heigth={6} 
                        domain={['dataMin', 'dataMax']} 
                        tickCount={200} 
                        tickSize={4}
                        tick={{fontSize: '0px'}}
                    />
                    <YAxis 
                        domain={['auto', 'dataMax => (dataMax * 2)']}
                        isAnimationActive={false}
                        tick={{fontSize: '10px'}}
                        orientation="left"
                        width={20}
                        tickSize={0}
                        tickFormatter={(item)=>{
                            if(Number(item) > 1000){
                                item = Number(item)/1000 + "K";
                            }
                            return item;
                        }}/>
                    <CartesianGrid vertical={false} isAnimationActive={false}/>
                    <Tooltip isAnimationActive={false} content={<CustomTooltip/>}/>
                    <Bar dataKey="Ops" stackId="a" fill="#278dc1" isAnimationActive={false}/>
                    <Bar dataKey="Txs" stackId="a" fill="#585274" isAnimationActive={false}/>
                </BarChart>
            </div>
        );
    }
} export default LedgersChart



// WEBPACK FOOTER //
// ./src/components/Stats/Charts/LedgersChart.js